module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg6-c07404b13ea04802e2f6059b6ad52a88.jpg";